// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { cn } from "@/lib/utils";

interface ProgressBarProps {
  /** Completed share of the work, 0..1. Values outside the range are clamped. */
  value: number;
  className?: string;
}

/**
 * Thin determinate progress track, shared by file uploads and by long-running back-end tasks that
 * report a counter. Pair it with an `InlineSpinner` whose label carries the wording.
 */
export function ProgressBar({ value, className }: ProgressBarProps) {
  const percent = Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div
      role="progressbar"
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn("h-1 w-full overflow-hidden rounded-full bg-muted", className)}
    >
      <div className="h-full bg-primary transition-[width] duration-150 ease-linear" style={{ width: `${percent}%` }} />
    </div>
  );
}
